import React, { useState } from "react";

export default function ImageViewer({
  imgSrcArray,
  setShowImgViewer,
  caption,
  firstImageToShow,
}) {
  const [currentIndex, setCurrentIndex] = useState(firstImageToShow || 0);
  const [hasZoomed, setHasZoomed] = useState(false);
  const totalLength = imgSrcArray && imgSrcArray.length;
  const currentElm = `${imgSrcArray[currentIndex]}`;

  const handleZoom = (zoomIn) => {
    setHasZoomed(true);
    const imgElm = document.getElementById("selectedImg");
    if (imgElm) {
      var currWidth = imgElm.clientWidth;
      var currHeight = imgElm.clientHeight;
      if (zoomIn) {
        imgElm.style.width = currWidth + 100 + "px";
        imgElm.style.height = currHeight + 100 + "px";
      } else {
        imgElm.style.width = currWidth - 100 + "px";
        imgElm.style.height = currHeight - 100 + "px";
      }
    }
  };

  return (
    <div id="img-viewer-modal" className="img-viewer-modal">
      <span onClick={() => setShowImgViewer(false)} className="close">
        &times;
      </span>
      <div className="imgContainer">
        <div className="imgWrap">
          <img
            id="selectedImg"
            className={`img-viewer-modal-content ${
              !hasZoomed ? "initialImage" : ""
            }`}
            src={currentElm}
            alt={currentElm}
          />
        </div>
        <div id="caption">{caption}</div>
      </div>
      <div id="nextPrvBtn">
        <button onClick={() => handleZoom(false)}>⊖</button>
        <button
          disabled={currentIndex === 0}
          onClick={() => setCurrentIndex(currentIndex - 1)}
        >
          ◄
        </button>
        <button
          disabled={currentIndex === totalLength - 1}
          onClick={() => setCurrentIndex(currentIndex + 1)}
        >
          ►
        </button>
        <button onClick={() => handleZoom(true)}>⊕</button>
      </div>
    </div>
  );
}
